import React, { useState } from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { ERouteLinks } from 'models/route';
import { Grid } from '@mui/material';
import { IAccountDataFormValues } from 'models/form';
import { useTranslation } from 'react-i18next';
import { EditAccountDataForm } from './EditAccountDataForm';
import { EditAccountDataConfirm } from './EditAccountDataConfirm';

const EditAccountDataPage = () => {
  const { t } = useTranslation();

  const [formStep, setFormStep] = useState(1);
  const [data, setData] = useState<IAccountDataFormValues | null>(null);

  const renderPage = () => {
    switch (formStep) {
      case 1:
        return (
          <EditAccountDataForm
            toConfirm={(formData: IAccountDataFormValues) => {
              setData(formData);
              setFormStep(2);
            }}
          />
        );
      case 2:
        return (
          <EditAccountDataConfirm
            cancel={() => {
              setFormStep(1);
            }}
            data={data}
          />
        );
      default:
        return <div />;
    }
  };

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t('page.myProfile.title'), route: ERouteLinks.MyProfile },
          t('page.myProfile.accountData.edit.title'),
        ]}
      />
      <StyledPageTitle variant="h4">
        {t('page.myProfile.accountData.edit.title')}
      </StyledPageTitle>
      <Grid container xs={12} md={8} lg={6} mt={2} rowGap={2}>
        {renderPage()}
        <Grid item>*{t('page.myProfile.accountData.edit.label.mandatoryField')}</Grid>
      </Grid>
    </>
  );
};

export { EditAccountDataPage };
